


















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Post } from '@/business/post/models/post'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import PostContainer from '@/business/post/components/post/post-container.vue'
import PostHeader from '@/business/post/components/post/post-header.vue'
import PostReplies from '@/business/post/components/post/post-replies.vue'
import PostAuthor from '@/business/post/components/post/post-author.vue'

@Component({
  name: 'respondeco-post',
  components: { PostAuthor, PostReplies, PostHeader, PostContainer, UnifyButton },
})
export default class RespondecoPost extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  post!: Post

  get hasReplies(): boolean {
    return this.post.replies.length > 0
  }
}
